export default "__VITE_ASSET__DhQWes4D__"